<template>
<div class='general'>

    <!-- ACCT NOTE MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form >
                <div class="rightjustified">
                    <smallbutton @click="$refs.mymodal.closeModal()" toplabel='X' buttonclass="buttonclose" />
                </div>
                <label class="titlelabel">Document Expiration</label>
                <div>
                    <label for="" class="pleasewait" v-if="pleaseWait">Please Wait...</label>
                </div>
                <div  class="mainform">
                    <div class="col">
                        
                       
                        <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Expiration Date</label>
                            </div>
                            <input type="date" class="entrySelect"  v-model="expirationDate" />
                        </div>
  
                        
                    </div>
  
                </div>
                <div >
                    <smallbutton  @click="save()" toplabel="Save" />
                    <!-- <smallbutton  @click="cancel()" toplabel="Cancel" /> -->
                </div>

                <div>
                    <label class="responsemessage">{{message}}</label>
               </div>
          </form>

            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>

import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'

export default {
    name:'getexpiration',
    components:{
        smallbutton,
        actionmodal,


    },
    props:{
        
    },
    mixins:[format],
    data(){
        return{

            message:'',
        
            pleaseWait:false,
            expirationDate:null,  
        }
    },
    computed:{
      
     
    },
    methods:{
       async ShowWithDate(date){
            console.log('expdate in ' + date)
           if(date ==undefined){
              this.expirationDate=  null
            }else{
                this.expirationDate=  this.$options.filters.formatDateForInput(date)
            }
            this.message=''
            this.$refs.mymodal.openModal()
            
        },
       
        async Show(){
           this.expirationDate=null
            this.message=''
            this.$refs.mymodal.openModal()
            
        },
        cancel(){
            this.$refs.mymodal.closeModal();
        },
        async save(){
            if(this.expirationDate==null){
                this.message='Please enter an expiration date'
                return
            }
            this.$emit('save',this.expirationDate)
            this.$refs.mymodal.closeModal();

        },
    
        
        
       
    },

}
</script>

<style>

</style>





























